const LINKEDIN_URL_REGEX = /^(http[s]?:\/\/)?([a-z]{2,3}\.)?linkedin\.com\/.*$/;

export default LINKEDIN_URL_REGEX;
